import { GenericDamage } from "../ts/visualModel";

export class GenericDamageHelper {
  /** Returns new damage. */
  public static cloneShallow<TDamage extends GenericDamage>(damage: TDamage): TDamage {
    return { ...damage };
  }

  /** Resets and returns new damage. */
  public static resetDamageType<TDamage extends GenericDamage>(damage: TDamage): TDamage {
    const newDamage = this.cloneShallow(damage);
    newDamage.damageTypeId = undefined;
    newDamage.damageType = undefined;
    newDamage.damageTypeRef = undefined;
    return newDamage;
  }

  /** Resets and returns new damage. */
  public static resetPartType<TDamage extends GenericDamage>(damage: TDamage): TDamage {
    const newDamage = this.cloneShallow(damage);
    newDamage.partTypeId = undefined;
    newDamage.partType = undefined;
    newDamage.partTypeRef = undefined;
    return newDamage;
  }

  /** Resets and returns new damage. */
  public static resetPartTypeAndDamageType<TDamage extends GenericDamage>(
    damage: TDamage,
  ): TDamage {
    return this.resetDamageType(this.resetPartType(damage));
  }
}
